import { render } from "./ProviderView.vue?vue&type=template&id=a1569016"
import script from "./ProviderView.vue?vue&type=script&lang=js"
export * from "./ProviderView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__